import { Record } from 'immutable'

import { type DeepNullable, EPublicRole } from '@albacross/types'

import type { CurrentUser } from '../api/Customer'
import type { CurrentUser as StoreCurrentUser } from '../store/Customer'
import { RoleRecord, roleFromServer } from './Role'

export const CurrentUserRecord = Record<DeepNullable<StoreCurrentUser>>({
  admin: false,
  authSource: '',
  contact: '',
  createdAt: null,
  customerUserId: null,
  email: '',
  firstName: '',
  id: 0,
  intercomHash: '',
  jobDepartment: null,
  jobTitle: null,
  lastName: '',
  username: '',
  verified: false,
  role: RoleRecord(),
  type: 0,
  mfaAvailable: false,
})

export const currentUserFromServer = (x: CurrentUser) =>
  CurrentUserRecord({
    admin: x.role.id === EPublicRole.Admin,
    authSource: x.registered_from,
    createdAt: x.created_at,
    email: x.email,
    firstName: x.first_name,
    id: x.id,
    intercomHash: x.intercom_hash,
    jobDepartment: x.job_department,
    jobTitle: x.job_title,
    lastName: x.last_name,
    verified: x.verified,
    role: roleFromServer(x.role),
    type: x.type,
    mfaAvailable: x.mfa_available,
  })
